import { useNavigate } from "@/lib/router-compat";
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => navigate(-1)}
      className="text-primary hover:text-primary/80 hover:bg-primary/10 h-9 w-9 mr-2"
      aria-label="Go back"
    >
      <ArrowLeft className="h-5 w-5" strokeWidth={2.5} />
    </Button>
  );
};

export default BackButton;
